/*
 * @Author: gjc
 * @Date: 2021-09-08 14:12:35
 * @LastEditTime: 2021-09-09 16:42:55
 * @LastEditors: Please set LastEditors
 * @Description: 全局指令
 * @FilePath: \fe-crworkbench-web\src\plugins\directive.js
 */
export default (Vue) => {
  // 点击文本复制
  Vue.directive('copy', {
    bind: function (el, { value }) {
      el.$value = value
      el.handler = () => {
        var input = document.createElement('input')
        input.value = el.$value
        el.appendChild(input)
        input.select()
        const res = document.execCommand('copy')
        if (res) {
          el.removeChild(input)
        }
      }
      el.addEventListener('click', el.handler)
    },
    unbind(el) {
      el.removeEventListener('click', el.handler)
    },
    componentUpdated(el, { value }) {
      el.$value = value
    }
  })
}
